import { AggregatedStatus, GatewaySearch } from '@vi-iot/client';

export const isNBIoTAndNotRegistered = ({
  installationId,
  aggregatedStatus,
}: GatewaySearch): boolean => !installationId && aggregatedStatus === AggregatedStatus.NBIoT;
